import React from 'react';
import { Button, Typography, Container, Box, Avatar } from '@mui/material';

const  PasswordConfirm = () => {
  const mailTo = process.env.REACT_APP_SUPPORT_MAIL_TO;
  return (
    <Container maxWidth="xs">
      <Box sx={{ mt: 1, display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
      <Avatar 
        alt="Logo" 
        src="logo.png" 
        variant="rounded" 
        sx={{
            height: 134,
            width: 134,
            maxHeight: { xs: 233, md: 167 },
            maxWidth: { xs: 350, md: 250 },
          }} />
       
        <Typography component="h1" variant="h5" sx={{ mt: 2 }}>
          Password Reset
        </Typography>
        <Box display="flex" sx={{ mt: 2, width: '100%', flexDirection: 'column', alignItems: 'center' }}>
            <Typography component="p" variant="body1">
                Your request is being processed.
            </Typography>

            <Typography component="p" variant="caption" align="center" sx={{ mt: 2 }}>
                Please check your email for instructions. If you do not
                see an email from us then please check your spam 
                folder. Failing that please contact support.
            </Typography>

            <Button 
                onClick={(e) => {
                    window.location = "mailto:" + mailTo;
                    e.preventDefault();
                }}
                variant="text"
                sx={{ mt: 3, fontWeight: 'bold', textTransform: 'capitalize' }}
            >
                Contact Support
            </Button>
        </Box>
      </Box>
    </Container>
  );
};
export default PasswordConfirm;